async function getCatalogAccessToken(config) {
  const credentials = btoa(config.clientId + ":" + config.clientSecret);
  const response = await fetch(config.authUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + credentials
    },
    body: "grant_type=client_credentials"
  });

  if (!response.ok) {
    throw new Error("Token request failed: " + response.status);
  }

  const data = await response.json();
  if (!data.access_token) {
    throw new Error("No access_token in response");
  }

  return data.access_token;
}

function showCatalogRequestError() {
  Swal.fire({
    title: "Something Went Wrong",
    html: `
      We weren’t able to send your inventory list at the moment. But don’t worry — our team has been notified and is already looking into it.
      <br><br>
      We’ll get back to you as soon as possible. If you need immediate assistance, feel free to reach out to your account executive. Thank you for your patience!
    `,
    showCloseButton: true,
    showCancelButton: false
  });
}

function isCatalogConfigValid(config) {
  return config &&
    config.authUrl &&
    config.serviceUrl &&
    config.clientId &&
    config.clientSecret;
}

$(function() {
  $("#download-catalog").click(async function(){
      
      var uid = $(this).attr("data-uid");
      var ccode = $(this).attr("data-ccode");
      var islogged = false;
      if(uid != undefined && uid != ""){
		    islogged = true;
      }

      if(!islogged){
         Swal.fire({
            title: "User not logged",
            html: `
              To download the catalog, you must be logged in. Please sign in.
            `,
            showCloseButton: true,
            showCancelButton: false
          });
          return;
      }

      $("#loading-pane").show();
      $("#download-catalog").attr("disabled", true);

      var catalogConfig = window.catalogApiConfig || {};
      if (!isCatalogConfigValid(catalogConfig)) {
        $("#loading-pane").hide();
        $("#download-catalog").attr("disabled", false);
        Swal.fire({
          title: "Catalog API is not configured",
          html: `
            Please configure the Catalog API credentials and endpoints in Theme settings before downloading the catalog.
          `,
          showCloseButton: true,
          showCancelButton: false
        });
        return;
      }

      var wrapper = {
        cardCode:ccode,
        email: uid 
      };

      console.log("Wrapper:", wrapper)

      try {
        var token = await getCatalogAccessToken(catalogConfig);

    	  var params = {
              type: "POST",
              url: catalogConfig.serviceUrl,
              data: JSON.stringify(wrapper),
              contentType: "application/json; charset=utf-8",
              headers: {
                "Authorization": "Bearer " + token
              },
              success: function(data) { 
                console.log("result");
                console.log(data);
                //download(data, "catalog.pdf", "#download-catalog");
                sendDataLayer({
                  "cardCode": "download-catalog",
                  "format": "pdf"
                });
                $("#loading-pane").hide();
                $("#download-catalog").attr("disabled", false);
                if(data.status) {
                  Swal.fire({
                    title: "Your inventory list is on its way.",
                    html: `
                      Check your inbox — it should arrive within the next few minutes.
                      <br><br>
                      If you don’t see it soon, be sure to check your spam or promotions folder.
                    `,
                    showCloseButton: true,
                    showCancelButton: false
                  });
                } else {
                  showCatalogRequestError();
                }
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest);
                console.log(textStatus);
                $("#loading-pane").hide();
                $("#download-catalog").attr("disabled", false);
                showCatalogRequestError();
              }
            };

        $.ajax(params);
      } catch (error) {
        console.log(error);
        $("#loading-pane").hide();
        $("#download-catalog").attr("disabled", false);
        showCatalogRequestError();
      }
  });

  $("#download-catalog-excel").click(function(){
      $("#loading-pane").show();
      $("#download-catalog-excel").attr("disabled", true);
      var uid = $(this).attr("data-uid");
      var islogged = false;
      if(uid != undefined && uid != ""){
		islogged = true;
      }
  	  var params = {
            type: 'GET',
            url: 'https://distritech-pdf.azurewebsites.net/api/pdf/getExcel/' + islogged,
            success: function(data) { 
              console.log("result");
              console.log(data);
              download(data, "catalog.xlsm", "#download-catalog-excel");
              sendDataLayer({
            	'eventType': 'download-catalog',
                "format": "excel"
              });
            },
            error: function(XMLHttpRequest, textStatus) {
              //geckoShopify.onError(XMLHttpRequest, textStatus);
              console.log(XMLHttpRequest);
              console.log(textStatus);
            }
          };
  
          $.ajax(params);
  });
});  

function download(url, filename, selectorBtn) {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      $("#loading-pane").hide();
      $(selectorBtn).attr("disabled", false);
  })
  .catch(console.error);
}
